<template>
  <div class="language-dropdown">
    <button class="dropdown-button" @click="toggleDropdown">
      <img
        :src="getFlag(this.$store.getters.language)"
        alt="Flag"
        class="flag-icon"
      />
      <span class="language-name">{{
        getLanguageName(this.$store.getters.language)
      }}</span>
      <img
        class="arrow"
        :class="{ rotate: dropdownOpen }"
        src="/arrows/open.svg"
      />
    </button>

    <ul v-if="dropdownOpen" class="dropdown-menu">
      <li
        v-for="(language, code) in languages"
        :key="code"
        @click="changeLanguage(code)"
        class="dropdown-item"
      >
        <img :src="getFlag(code)" alt="Flag" class="flag-icon" />
        <span class="language-name">{{ getLanguageName(code) }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dropdownOpen: false,
      languages: {
        en: { de: "Englisch", en: "English", fr: "Anglais", it: "Inglese", nl: "Engels" },
      },
    };
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    changeLanguage() {
      this.$store.commit("setLanguage", "en");
      this.$store.commit("setCurrency", "EUR");
      this.$store.dispatch("getProducts");
      this.$i18n.locale = "en";
      this.dropdownOpen = false;
      const url = new URL(window.location.href);
      url.searchParams.set("lang", "en");
      window.history.replaceState({}, "", url);
    },

    getFlag(code) {
      return `/flags/${code}.svg`;
    },

    getLanguageName(languageCode) {
      return this.languages[languageCode][this.$store.getters.language];
    },

    loadLanguageFromURL() {
      this.changeLanguage("en");
    },
  },
  mounted() {
    this.loadLanguageFromURL();
  },
};
</script>

<style>
.language-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-button {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 7.5px 5px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dropdown-button:hover {
  background-color: #f3f3f3;
}

.flag-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
}

@media (max-width: 815px) {
  .language-name {
    display: none;
  }
}

.language-name {
  font-size: 16px;
  font-weight: 500;
  margin-right: 10px;
  color: #333;
  white-space: nowrap;
}

.arrow {
  font-size: 16px;
  color: #666;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 190px;
  width: 100%;
  background-color: #ffffff;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  z-index: 1000;
  padding: 5px 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f3f3f3;
}

.flag-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}

.dropdown-item .language-name {
  font-size: 14px;
  color: #333;
}

.flag-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}
</style>
